export default "__VITE_ASSET__C2a94d47__"